import { RSFormState } from './types';
import { CheckTrigger } from './enums';

export const initialRSFormState: RSFormState = {
  formValue: {},
  formError: {},
  checkTrigger: CheckTrigger.Change
};
